import React, { useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ControlOutlined, NodeIndexOutlined, ThunderboltOutlined, MobileOutlined, CameraOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MainLayout from 'layouts/MainLayout';
import {isConfigAdmin, isHeadquartersAdmin} from 'utils/auth';
import { findFirstAvailableMenuItem } from 'utils/menuUtils';

const ConfigLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const menuItems = [
        {
            key: 'common-config',
            icon: <ControlOutlined />,
            label: t('commonConfig.title'),
            display: isHeadquartersAdmin() || isConfigAdmin(),
            onClick: () => navigate('/config/common-config')
        },
        {
            key: 'pod-capture-config',
            icon: <CameraOutlined />,
            label: 'POD拍摄配置',
            display: isHeadquartersAdmin() || isConfigAdmin(),
            onClick: () => navigate('/config/pod-capture-config')
        },
        {
            key: 'pod-capture-config-v2',
            icon: <CameraOutlined />,
            label: 'POD拍摄配置V2',
            display: isHeadquartersAdmin() || isConfigAdmin(),
            onClick: () => navigate('/config/pod-capture-config-v2')
        },
        {
            key: 'entry-config',
            icon: <NodeIndexOutlined />,
            label: t('config.menu.entryConfig'),
            display: isHeadquartersAdmin() || isConfigAdmin(),
            onClick: () => navigate('/config/entry-config')
        },
        {
            key: 'degrade',
            icon: <ThunderboltOutlined />,
            label: t('degrade.menu.title'),
            display: isHeadquartersAdmin() || isConfigAdmin(),
            onClick: () => navigate('/config/degrade')
        },
        {
            key: 'app-version',
            icon: <MobileOutlined />,
            label: t('central.appVersion.title'),
            display: isHeadquartersAdmin(),
            onClick: () => navigate('/config/app-version')
        },
    ];

    useEffect(() => {
        const isRoot = location.pathname === '/config' || location.pathname === '/config/';
        if (!isRoot) return;
        const first = findFirstAvailableMenuItem(menuItems);
        if (first?.onClick) first.onClick();
    }, [location.pathname, menuItems]);

    return (
        <MainLayout
            activeFirstMenu="config"
            secondMenu={menuItems}
        >
            <div className="p-6 h-full flex flex-col">
                <Outlet />
            </div>
        </MainLayout>
    );
};

export default ConfigLayout;
